import React from 'react';
import { motion } from 'framer-motion';
import { data } from '@/data';
import SEO from '@/components/SEO';
import { getPageSEO } from '@/config/seoConfig';
import { useTranslation } from '@/hooks/useTranslation';

const Media = () => {
  const seoData = getPageSEO('media');
  const t = useTranslation();
  
  return (
    <>
      <SEO 
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        url={seoData.url}
        image={seoData.image}
        type="website"
      />
      <div className="min-h-screen bg-gradient-to-br from-blue-50/30 to-indigo-50/20 pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-playfair text-4xl md:text-5xl lg:text-6xl mb-16 text-gray-800 text-center font-semibold tracking-tight"
        >
          {t.media.title}
        </motion.h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.videos.map((video, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group relative aspect-video overflow-hidden bg-gray-100 hover:shadow-2xl transition-shadow duration-300"
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full transform group-hover:scale-105 transition-transform duration-500"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default Media;